import React from 'react';

import Image from '../../../image/image';
import Typography from '../../../typography/typography';

import './fitment-tire-size-help-guide.scss';

interface FitmentTireSizeHelpGuideProps {
  className?: string;
  title?: string;
}
function FitmentTireSizeHelpGuide(props: FitmentTireSizeHelpGuideProps) {
  const { className = '', title } = props;

  return (
    <div
      className={`${className} fitment-tire-size-help-guide__container`}
      styleName="container"
    >
      {title && (
        <Typography variant="H6" weight="black">
          Where to find: {title}
        </Typography>
      )}
      <div className="fitment-tire-size-help-guide__row" styleName="row">
        <div styleName="left-col">
          <Typography styleName="content">
            There are two places to find your tire size. Look directly on your
            tire sidewall or inside your driver’s side door jamb for the
            information specific to your vehicle’s original tire size or current
            tire size.
          </Typography>
          <div styleName="tire-details">
            <Typography size="small" weight="heavy">
              Example tire size:
            </Typography>
            <Image
              alt="Tire details example"
              src={`${process.env.__CDN_ORIGIN__}/sys-master/images/hc6/h53/9411949297694/Tire_Size_Description_Breakdown.png`}
            />
          </div>
        </div>
        <div styleName="right-col">
          <div styleName="tire-sidewall-example">
            <Typography size="small" styleName="title" weight="heavy">
              On tire sidewall example:
            </Typography>
            <Image
              alt="Tire details example"
              src={`${process.env.__CDN_ORIGIN__}/sys-master/images/h2e/h1f/9422115831838/Sidewall_Desciption_Pointed_Out_v2.png`}
            />
          </div>
          <div styleName="inside-door-example">
            <Typography size="small" styleName="title" weight="heavy">
              Inside door jamb example:
            </Typography>
            <Image
              alt="Inside door jamb example"
              src={`${process.env.__CDN_ORIGIN__}/sys-master/images/h16/hea/9411946250270/Tire_Loading_Information.png`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FitmentTireSizeHelpGuide;
